// Sous-plan 10 : la page Assistant de l'app Pirouette charge la SPA dans un iframe de meme origine.
// Dans ce mode, Navigation rend la liste des conversations de Dust a la place du rail compta.
// La detection se fait par la fenetre (self !== top), jamais par un parametre d'URL : rien a faire
// survivre aux navigations du routeur, et une visite directe de /chat/ reste inchangee.

export interface FenetreMinimale {
  self: unknown;
  top: unknown;
}

export function estIntegre(fenetre: FenetreMinimale | undefined): boolean {
  if (!fenetre) {
    return false;
  }
  try {
    return fenetre.self !== fenetre.top;
  } catch {
    // Lire top peut lever dans un cadre d'origine etrangere : c'est alors un iframe.
    return true;
  }
}

export function modeIntegre(): boolean {
  return estIntegre(typeof window === "undefined" ? undefined : window);
}

// Largeur de la colonne en mode intégré : celle de la barre de Dust (w-80, 320 px) et de l'ancienne
// barre de l'app (remarque de Louka du 01/10).
export const LARGEUR_BARRE_INTEGREE = "w-80";
